import { Component } from 'react';
import PersonalizationEditorContext from 'ContentComponents/context/PersonalizationEditorContext';
import { jsx as _jsx } from "react/jsx-runtime";
class DataTokenProvider extends Component {
  constructor(props) {
    super(props);
    this.handlePersonalizationRefUpdate = this.handlePersonalizationRefUpdate.bind(this);
    this.state = {
      TokenViewerComponent: this.props.TokenViewerComponent,
      editorRefs: {},
      setEditorRefs: this.handlePersonalizationRefUpdate
    };
  }
  handlePersonalizationRefUpdate(fieldKey, ref) {
    const {
      editorRefs = {}
    } = this.state;
    editorRefs[fieldKey] = ref;
    this.setState({
      editorRefs
    });
  }
  render() {
    const {
      children
    } = this.props;
    return /*#__PURE__*/_jsx(PersonalizationEditorContext.Provider, {
      value: this.state,
      children: children
    });
  }
}
export default DataTokenProvider;